import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-venue-poc-table',
  standalone: false,
  templateUrl: './venue-poc-table.component.html',
  styleUrl: './venue-poc-table.component.scss',
})
export class VenuePocTableComponent {
  @Input() pocList: any[] = [];
  @Output() edit = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() setPrimary = new EventEmitter<any>();
  @Output() openModal = new EventEmitter<any>();

  editPOC(poc: any) {
    this.edit.emit(poc);
  }

  deletePOC(poc: any) {
    this.delete.emit(poc.id);
  }

  setPrimaryPOCDetail(event: boolean, poc: any) {
    this.setPrimary.emit({ event, poc });
  }

  openPOCModal(poc: any) {
    this.openModal.emit(poc);
  }
}
